export default "__VITE_ASSET__C2faPYm1__"